/* global window, rp$, document */
const $onReady = require('public/js/lib/on-ready');
const getCart = () => import(/* webpackChunkName: "get-cart" */ 'public/js/components/cart');
const addToCartSelector = '.add-to-cart.enabled';

const  handleAddToCartModule = () => {
	//Only Add the cart.js to the page if there is at least 1 add to cart button.
	const cartButton = document.querySelector(addToCartSelector);
	if (cartButton) {
		getCart().then((module) => {
			module.attachAddToCartEvents(addToCartSelector);
		});
	}
};

$onReady({rp$, window,
	label: 'get-cart',
	fn: function () {
		handleAddToCartModule();
	},
});
